import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PublicacaoService } from 'src/app/services/publicacao/publicacao.service';
import { OfertaCliente } from 'src/models/interfaces/publicacao/publicacao-interface';

@Component({
    selector: 'spe-termo-generico',
    templateUrl: './termo-generico.component.html',
    styleUrls: ['./termo-generico.component.scss'],
    standalone: false
})
export class TermoGenericoComponent {
  @Input() oferta: OfertaCliente | undefined;

  public imagem: string | undefined;
  public html: SafeHtml | undefined;
  public showModal: boolean = true;
  public showPublicacaoImagem = false;

  constructor(private publicacaoService: PublicacaoService, private domSanitizer: DomSanitizer) {}

  ngOnInit(): void {
    if (this.oferta) {
      if (this.oferta.publicacaoImagem == 'N') {
        let modifiedString = atob(this.oferta.materia).replace(/style\s*=\s*['"][^'"]*['"]/gi, '');
        modifiedString = modifiedString.replace('<img', '<img style="width: 100%;"');
        this.html = this.domSanitizer.bypassSecurityTrustHtml(modifiedString);
      } else {
        this.showPublicacaoImagem = true;
        this.imagem = `data:image/png;base64,${this.oferta.materia}`;
      }
    } else {
      this.showModal = false;
    }
  }

  submitForm(aceitou: boolean) {
    if (!aceitou) {
      this.publicacaoService.recusarOfertaPopUp(this.oferta!.idCanal).subscribe({
        next: () => {
          this.showModal = false;
        }
      });
    } else {
      this.publicacaoService.aceitarOfertaPopUp(this.oferta!.idCanal).subscribe({
        next: () => {
          this.showModal = false;
        }
      });
    }
  }
}
